import React from "react";
import cx from "classnames";

import { StoredValue } from "components/Icon.js";
import CmsContentRenderer from "components/data/CmsContentRenderer.js";
import CmsContentList from "components/data/CmsContentList.js";

import * as tables from "components/DataTable.module.css";

const cms = {
	cash: 'miscText.purchasehistory-table-product-cash',
};

const CashChip = ({	overrideClass = null }) =>
	<CmsContentList list={Object.values(cms)}>{() =>
		<div className={tables.cashIconWrapper}>
			<StoredValue
				aria-hidden="true"
				data-qa="cash-icon"
			/>

			<CmsContentRenderer.Span
				className={cx(tables.cashText, overrideClass)}
				contentKey={cms.cash}
				fallbackValue="Cash"
			/>
		</div>
	}</CmsContentList>;

export default CashChip;
